module.exports = __webpack_public_path__ + "img/git.855438ce.svg";